/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  adminsection: {
    zIndex: 10,
    position: 'relative',
    '& .collapsable.opened': {
      maxHeight: pxToRem(3000),
      overflow: 'visible'
    }
  }
});
